/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';
import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faThumbtack } from '@fortawesome/pro-duotone-svg-icons';

import { Paper, IconButton, Tooltip, Breadcrumbs, Typography, TextField, CircularProgress, Card, CardContent } from '@material-ui/core'
import { ArrowBack, Edit, Clear } from '@material-ui/icons'

import GroupIcon from './GroupIcon'
import RecordIcon from '../Records/RecordIcon'
import GlobalFieldSelect from '../UtilComps/GlobalFieldSelect';
import RecordList from '../Records/RecordList';
import Action from '../../../../../fluid/Actions/ActionFactory'

import Record from '../Records/Record';


const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({

})

class GroupDetail extends Component {
    state = {
        edit_name : false,
        new_name : null,
        editing_name : false,
        editing_name_error : false,
        setting_primary_record : false,
        setting_primary_record_error : false,
        focus_record : false,
        record_in_focus : null
    }

    componentDidMount() {
        console.log('IRC :: Global Concepts ', this.props.global_fields)
    }

    isPinned = (group_object) => {
        if (this.props.pinned_groups.length === 0) {
            return false
        }
        
        let group_id = group_object.group_id
        let pin_idx = this.props.pinned_groups.findIndex(pinned_group_id => pinned_group_id === group_id)

        if (pin_idx !== -1) {
            return true
        } else {
            return false
        }
    }

    pinGroup = (event) => {
        event.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();
        if (this.props.is_pinned) {
            this.props.pin_group(this.props.group_data.group_id, "unpin")
        } else {
            this.props.pin_group(this.props.group_data.group_id, "pin")
        }
    }

    getAnimationDirection = () => {
        if (this.props.checking_merge_groups) {
            if (this.props.location === 'GroupSpace') {
                console.log("IFC :: Group Animate Left", this.props.group_data.group_name)
                return 'left'
            }
            
            if (this.props.location === 'RecoSpace') {
                console.log("IFC :: Group Animate Right", this.props.group_data.group_name)
                return 'right'
            }
        } else {
            return null
        }
    }

    renderNavigation = () => {
        return (
            <Paper 
                variant = 'outlined'
                square
                style = {{
                    width : '100%',
                    height : '50px',
                    display : 'flex',
                    flexDirection : 'row'
                }}
            >
                <div style = {{
                    display : 'flex',
                    flexDirection : 'row',
                    alignItems : 'center',
                    justifyContent : 'center'
                }}>
                    <Tooltip title = "Back">
                        <IconButton size = 'small' color = 'primary' onClick = {() => this.props.unfocus_group()}>
                            <ArrowBack fontSize = 'inherit'/>
                        </IconButton>
                    </Tooltip>
                </div>
                <div style = {{
                    display : 'flex',
                    flexDirection : 'row-reverse',
                    alignItems : 'center',
                    flexGrow : 1,
                    padding : '10px'
                }}>
                    {this.props.from && <Breadcrumbs>
                        {this.props.from.split("/").map(loc => {
                            return (
                                <Typography variant = 'caption' color = 'textSecondary'>{loc}</Typography>
                            )
                        })}
                        {this.props.group_data && <Typography variant = 'caption' color = 'primary'>{this.props.group_data.group_name}</Typography>}
                        {this.state.record_in_focus && <Typography variant = 'caption' color = 'primary'>{this.state.record_in_focus.record_id}</Typography>}
                    </Breadcrumbs>}
                </div>
            </Paper>
        )
    }

    renderDetails = () => {
        return (
            <Paper
                variant = 'outlined'
                square
                style = {{
                    width : '100%',
                    height : '210px',
                }}
            >
                <div 
                    style = {{
                        width : '100%',
                        height : '60px',
                        display : 'flex',
                        flexDirection : 'row',
                        alignItems : 'center',
                        borderBottom : '1px solid rgba(0,0,0,0.12)'
                    }}
                >
                        {!this.state.edit_name && !this.props.checking_merge_groups && 
                        <div style = {{padding : '10px'}} onClick = {() => this.props.pin_group(this.props.group_data.group_id, this.isPinned(this.props.group_data) ? "unpin" : "pin")}>
                            {this.isPinned(this.props.group_data) ? 
                                <Tooltip title = "Unpin Group">
                                    <div>
                                        <FontAwesomeIcon 
                                            style = {{
                                                transform : 'rotate(-90deg)',
                                                color : "#fc0303",
                                                cursor : 'pointer'
                                            }} 
                                            icon = {faThumbtack}
                                        /> 
                                    </div>
                                </Tooltip>
                                : 
                                <Tooltip title = "Pin Group">
                                    <div>
                                        <FontAwesomeIcon 
                                            style = {{
                                                transform : 'rotate(-45deg)',
                                                opacity : '0.5',
                                                cursor : 'pointer'
                                            }} 
                                            icon = {faThumbtack}
                                        />
                                    </div>
                                </Tooltip>
                            }
                        </div>
                        }
                        <div 
                            style = {{
                                flexGrow : 1,
                                height : '100%',
                                display : 'flex',
                                flexDirection : this.getAnimationDirection() === null ? 'row' : this.getAnimationDirection() === 'left' ? 'row' : 'row-reverse',
                                alignItems : 'center'
                            }}
                        >
                            {this.renderGroupName()}
                        </div>
                        {!this.state.edit_name && this.props.allow_name_edit && !this.props.checking_merge_groups && 
                        <div style = {{padding : '10px'}}>
                            <Tooltip title = "Edit">
                                <IconButton size = 'small' onClick = {() => this.setState({...this.state, edit_name : true})}>
                                    <Edit fontSize = 'inherit'/>
                                </IconButton>
                            </Tooltip>
                        </div>}
                </div>  
                <div
                    style = {{
                        width : '100%',
                        height : '65px',
                        borderBottom : '1px solid rgba(0,0,0,0.12)'
                    }}
                >
                    <GlobalFieldSelect
                        ic_name = {this.props.ic_name}
                        version = {this.props.version}
                        step_tag = {this.props.step_tag}
                        global_field_display_name = {this.props.global_field_display_name} 
                        group_data = {this.props.group_data} 
                        global_mapped_field = {this.props.group_data ? this.props.group_data.global_mapped_concept : null} 
                        global_fields = {this.props.global_fields}
                        global_fields_error = {this.props.global_fields_error}
                        field_in_focus = {this.props.field_in_focus}
                        mapping_global_field = {this.props.mapping_global_field}
                        map_global_field = {(entity_id, global_field) => this.props.map_global_field(entity_id, global_field)}
                        create_global_field = {(entity_id, new_field_name) => this.props.create_global_field(entity_id, new_field_name)}
                    />
                </div>
                <div
                    style = {{
                        width : '100%', 
                        height : '70px',
                        display : this.getAnimationDirection() === null ? 'flex': 'none',
                        flexDirection : 'row',
                        justifyContent : 'center',
                        alignItes : 'center',
                        padding : '10px'
                    }}
                >
                    {this.props.group_data && this.props.group_data.rank && <Paper
                        style = {{
                            width : '70px',
                            height : '70px',
                            marginRight : '5px',
                            display : 'flex',
                            flexDirection : 'column',
                            alignItems : 'center'
                        }}
                    >
                        <Typography variant = 'caption' color = 'textSecondary'>Rank</Typography>
                        <div style = {{width : '100%', flexGrow : 1, display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                            <Typography style = {{color : "#00BAFF", fontSize : 23, fontWeight : 600 }} variant = 'subtitle2'>{"#" + this.props.group_data.rank}</Typography>
                        </div>
                    </Paper>}
                    {this.props.group_data.group_score && <Paper
                        style = {{
                            width : '70px',
                            height : '70px',
                            marginRight : '5px',
                            display : 'flex',
                            flexDirection : 'column',
                            alignItems : 'center'
                        }}
                    >
                        <Typography variant = 'caption' color = 'textSecondary'>Score</Typography>
                        <div style = {{width : '100%', flexGrow : 1, display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                            <Typography style = {{color : '#03AD93', fontSize : 23, fontWeight : 600 }} variant = 'subtitle2'>{this.props.group_data.group_score.toFixed(2)}</Typography>
                        </div>
                    </Paper>}
                    {this.props.group_data.records && <Paper
                        style = {{
                            width : '70px',
                            height : '70px',
                            marginRight : '5px',
                            display : 'flex',
                            flexDirection : 'column',
                            alignItems : 'center'
                        }}
                    >
                        <Typography variant = 'caption' color = 'textSecondary'>Records</Typography>
                        <div style = {{width : '100%', flexGrow : 1, display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                            <Typography style = {{color : '#03AD93', fontSize : 23, fontWeight : 600 }} variant = 'subtitle2'>{this.props.group_data.records.length}</Typography>
                        </div>
                    </Paper>}
                </div>
            </Paper>
        )
    }

    handleNameChange = (event) => {
        this.setState({...this.state, new_name : event.target.value})
    }

    handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            this.changeName()
        }
    }

    setRecordPrimary = (field_data) => {
        this.setState({...this.state, setting_primary : true , setting_primary_error : false}, () => {
            Action('http_request', {
                url : "/sainapse/irc/set_record_as_primary",
                method : "post",
                data : {
                    ic_name : this.props.ic_name,
                    version : this.props.version,
                    record_id : field_data.record_id,
                    step_tag : this.props.step_tag
                }
            }).then(res => {
                this.setState({...this.state, setting_primary_record : false, setting_primary_record_error : false}, () => this.props.refresh_space(this.props.group_data.group_id))
            }).catch(err => {
                this.setState({...this.state, setting_primary_record : false, setting_primary_record_error : true})
            })
        })
    }

    changeName = () => {
        this.setState({...this.state, editing_name : true, editing_name_error : false}, () => {
            Action("http_request", {
                url : "/sainapse/irc/change_group_name",
                method : "post",
                data : {
                    group_id: this.props.group_data.group_id,
                    ic_name: this.props.ic_name,
                    new_name: this.state.new_name,
                    version: this.props.version,
                    step_tag : this.props.step_tag
                }
            }).then(res => {
                this.setState({...this.state, editing_name : false, editing_name_error : false, edit_name: false, new_name : null}, () => this.props.refresh_space(this.props.group_data.group_id))
            }).catch(err => {
                this.setState({...this.state, editing_name : false, editing_name_error : true, edit_name: true})
            })
        })
    }

    renderGroupName = () => {
        if (this.state.edit_name) {
            return (
                <div style = {{padding : '5px', width : '100%', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                    <TextField
                        style = {{flexGrow : 1}}
                        variant = 'outlined'
                        size = 'small'
                        label = {this.props.group_display_name + " Name"}
                        placeholder = {this.props.group_data.group_name}
                        value = {this.state.new_name}
                        fullWidth
                        onChange = {this.handleNameChange}
                        onKeyDown = {this.handleKeyDown}
                        error = {this.state.editing_name_error}
                    />
                    {!this.state.editing_name ? 
                    <IconButton style = {{margin: '5px'}} size = "small" onClick = {() => this.setState({...this.state, edit_name : false, new_name : null, editing_name : false, editing_name_error: false})}>
                        <Clear fontSize = "inherit"/>
                    </IconButton> :
                    <CircularProgress style = {{margin: '5px'}} variant = 'indeterminate' color = 'primary' size = {20}/>}
                </div>
            )
        } else {
            return (
                <Fragment>
                    <div style = {{padding : '10px'}}>
                        <GroupIcon group_display_name = {this.props.group_display_name}/>
                    </div>
                    <div>
                        <Typography variant = 'caption' display = 'block' color = 'textSecondary'>{this.props.group_display_name + " Name"}</Typography>
                        {this.props.group_data && <Typography variant = 'subtitle2' color = 'textPrimary'>{this.props.group_data.group_name}</Typography>}
                    </div>
                </Fragment>
            )
        }
    }

    getRecords = () => {
        let records = this.props.group_data.records.map((record, i) => {
            let record_obj = {
                ...record,
                group_id : this.props.group_data.group_id,
                group_name : this.props.group_data.group_name,
                score : this.props.group_data.record_scores[i],
                record_status : this.props.group_data.record_status[i],
                record_type : this.props.group_data.record_type[i],
            }

            return record_obj
        })

        console.log("IRC :: Record List : ", records)
        return records
    }

    renderRecord = () => {
        console.log("IRC :: Record In Focus : ", this.state.record_in_focus)
        return(
            <Record 
                record={this.state.record_in_focus} 
                unfocus_record = {() => this.setState({...this.state, record_in_focus : null})}
                unfocus_field = {()=>this.props.unfocus_field}
            ></Record>
        )
    }

    renderFields = () => {
        let columns = ["$icon","$options","$primary", "$golden"]
        Object.keys(this.props.group_data.records[0].wv_field_list).map((field) => columns.push(field))
        columns.push("Score")
        //columns = ["$icon", "Name", "Score", "$options"]
        return (
            <div style = {{width : '100%', flexGrow : 1}}>
                <Typography style = {{marginLeft : '10px'}} variant = 'subtitle2'>{this.props.field_display_name + "s"}</Typography>
                <RecordList
                    columns = {columns}
                    group_data = {this.props.group_data}
                    group_display_name = {this.props.group_display_name}
                    field_display_name = {this.props.field_display_name}
                    body_height = {this.props.body_height - 315}
                    top_margin = "0px"
                    fields = {this.getRecords()}
                    location = {this.props.location}
                    field_in_focus = {this.props.field_in_focus}
                    focus_field = {(field_object, field_type) => {
                        this.setState({...this.state, record_in_focus : field_object, field_in_focus : field_object}, () => this.props.focus_field(field_object, field_type))
                    }}
                    accept_field_drops = {this.props.accept_field_drops}
                    field_type = {'record'}
                    move_field = {(field_data, field_type, drop_result) => this.props.move_field(field_data, field_type, drop_result)}
                    syncing_field = {this.props.syncing_field}
                    column_index = {this.props.column_index}
                    unfocus_field = {() => this.props.focus_field(null, null, () => this.props.update_space_state(1, null))}
                    unsynced_fields = {this.props.unsynced_fields}
                    create_new_group_from_field = {(field_data) => this.props.create_new_group_from_field(field_data)}
                    make_singleton = {(field_data) => this.props.make_singleton(field_data)}
                    pagination = {true}
                    group_filter = {this.props.group_filter}
                    update_filter = {(group_filter) => this.props.update_filter(group_filter)}
                    record_in_focus = {this.state.record_in_focus}
                    focus_record = {(record)=> this.setState({...this.state,record_in_focus : record})}
                    report_info = {this.props.report_info}
                    set_record_primary = {(field_data) => this.props.set_record_primary(field_data)}
                />
            </div>
        )
    }

    render() {
        return (
            <ThemeProvider>
                <div 
                    style = {{
                        width : '100%', 
                        height : this.props.body_height + "px", 
                        backgroundColor : "#F5F5F5", 
                        overflow : "hidden",
                        display : 'flex',
                        flexDirection : 'column'
                    }}
                >
                    {this.renderNavigation()}
                    {!this.state.record_in_focus && this.renderDetails()}
                    {this.state.record_in_focus !== null ? this.renderRecord() : this.renderFields()}
                </div>
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(GroupDetail);